import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.pad-start.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { submitMaterialReturn } from '../api/index.js';
import MaterialReturnSelectDrawer from './materialReturnSelectDrawer.vue';
export default {
  name: 'materialReturnApplyDrawer',
  components: {
    MaterialReturnSelectDrawer: MaterialReturnSelectDrawer
  },
  data: function data() {
    var getCurrentDate = function getCurrentDate() {
      var d = new Date();
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
      submitLoading: false,
      loading: false,
      drawerSelect: false,
      excludedIds: [],
      form: {
        refund_user_id: '',
        date: getCurrentDate(),
        remark: '',
        material_items: []
      }
    };
  },
  computed: {
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  },
  methods: {
    changeRefundUser: function changeRefundUser() {
      this.form.material_items = [];
    },
    getReturnableNum: function getReturnableNum(row) {
      var receive = Number(row.receive_num) || 0;
      var refunded = Number(row.refund_num) || 0;
      return Math.max(receive - refunded, 0);
    },
    validateReturnNum: function validateReturnNum(rule, value, cb, row) {
      if (value === '' || value === null || value === undefined) {
        return cb();
      }
      var num = Number(value);
      if (!/^[1-9]\d*$/.test(String(value))) {
        return cb();
      }
      var max = this.getReturnableNum(row);
      if (num > max) {
        return cb(new Error("\u672C\u6B21\u9000\u8FD8\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7\u53EF\u9000\u6570\u91CF ".concat(max)));
      }
      cb();
    },
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this.form.material_items.length === 0) {
            _this.$message.warning('请至少添加一个物料');
            return;
          }
          _this.submitLoading = true;
          var params = {
            refund_user_id: _this.form.refund_user_id,
            date: _this.form.date,
            remark: _this.form.remark,
            material_items: _this.form.material_items.map(function (item) {
              return {
                id: item.id,
                num: item.num
              };
            })
          };
          submitMaterialReturn(params).then(function () {
            _this.$message.success('操作成功');
            _this.$emit('emitGetList');
            _this.submitLoading = false;
          }).finally(function () {
            _this.submitLoading = false;
          });
        }
      });
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleAddMaterial: function handleAddMaterial() {
      if (!this.form.refund_user_id) {
        this.$message.warning('请选择【退还人】后再操作');
        return;
      }
      this.drawerSelect = true;
    },
    handleMaterialSelected: function handleMaterialSelected(materials) {
      var list = (materials || []).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          num: ''
        });
      });
      this.form.material_items = _toConsumableArray(list);
      this.drawerSelect = false;
    },
    handleRemove: function handleRemove(index) {
      this.form.material_items.splice(index, 1);
    }
  }
};